<template>

  <div class="col-xs-12">
    <h1 class="page-heading">
      Roundupper
    </h1>
  </div>

</template>

<script>
  
  export default {

  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// header.vue?f2f5e032